import { Box, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { TFunction } from 'i18next';
import { images } from '../../assets/images';
import { appEnvironment } from '../../common/environment';
import { OnboardingV2Step } from '../../redux/onboardingTypes';
import TermsAndPrivacyNotice from '../legal/TermsAndPrivacyNotice';

interface ActionFooterProps {
  step: OnboardingV2Step;
  isAnimatingPhase: boolean;
  loading: boolean;
  showingMessages: boolean;
  buttonEnabled: boolean;
  onContinue: () => void;
  t: TFunction;
}

export default function ActionFooter({
  step,
  isAnimatingPhase,
  loading,
  showingMessages,
  buttonEnabled,
  onContinue,
  t,
}: ActionFooterProps) {
  const isSyd = appEnvironment.theme.appName.toLowerCase() === 'syd';

  if (isAnimatingPhase) {
    return (
      <Stack className="w-full mb-[40px] z-20 relative" alignItems="center">
        <Typography className="font-medium text-[14px] text-[#26262680]">
          {t('establishingPrivateAndSecureConnection')}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      className="macbook13:my-0 macbook13:mb-[10px] my-[16px] z-20 relative"
      alignItems="center"
    >
      {/* Disclaimer for non-Syd brands (Altius) */}
      {!isSyd && (
        <span
          className="text-[12px] font-normal max-w-[700px] macbook13:hidden"
          style={{ color: appEnvironment.theme.colours.secondaryGrayText }}
        >
          {t('disclaimer').replace(/syd/gi, appEnvironment.theme.appName)}
        </span>
      )}

      {/* Action Button */}
      <LoadingButton
        variant="contained"
        endIcon={
          loading || showingMessages ? undefined : (
            <Box component="img" src={images.v2.button.tick} />
          )
        }
        className={`button large bg-text ${
          step !== OnboardingV2Step.WELCOME ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onContinue}
        loading={loading || showingMessages}
        disabled={!buttonEnabled || showingMessages}
      >
        {step === OnboardingV2Step.SUMMARY
          ? t('completeSignUp')
          : isSyd && step === OnboardingV2Step.SIGN_UP
          ? t('createAccount', 'Create Account')
          : t('continue')}
      </LoadingButton>

      {/* Acceptance notice directly beneath the button on Sign Up step */}
      {isSyd && step === OnboardingV2Step.SIGN_UP && (
        <TermsAndPrivacyNotice className="mt-[12px] max-w-[550px]" />
      )}
    </Stack>
  );
}
